import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';
import { Classroom360Service } from '../../../classroom360/classroom360.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { FormWithinDocumentsService } from '../../../sped360/forms-within-documents/form-within-documents.service';
import { EditHtmlFormComponent } from '../../../sped360/forms-within-documents/modals/edit-html-form/edit-html-form.component';
import { Student360Service } from '../../../student360/student360.service';
import { StudentInfoPortalComponent } from '../../student-information/student-info-portal/student-info-portal.component';
import { Enrollment } from '../../student/enrollment.model';
import { Student } from '../../student/student.model';
import { StudentService } from '../../student/student.service';
import { System } from '../../System';
import { UserService } from '../../user/user.service';
import { YearService } from '../../year/year.service';

@Component({
  selector: 'app-alerts-dialog',
  templateUrl: './alerts-dialog.component.html',
  styleUrls: ['./alerts-dialog.component.css']
})
export class AlertsDialogComponent implements OnInit {
  @ViewChild('dateTpl') dateTpl: TemplateRef<any>;
  @ViewChild('iconTpl') iconTpl: TemplateRef<any>;
  studentId: number;
  isV10: boolean;
  student: Student;
  studentEnrollment: Enrollment;
  gridHeight;
  alerts: Alert[] = [];
  displayedColumns: string[] = ['alertIcon', 'description', 'start', 'end'];
  junkDateString = System.junkDateString;
  portalDialog: MatDialogRef<StudentInfoPortalComponent>;
  isIEP = true;
  useSection504 = false;

  constructor(
    private studentService: StudentService,
    private userService: UserService,
    private yearService: YearService,
    public dialogRef: MatDialogRef<AlertsDialogComponent>,
    private loginService: LoginService,
    @Inject(MAT_DIALOG_DATA) public data: Alert[],
    private router: Router,
    private dialog: MatDialog,
    private parentPortalService: Student360Service,
    private classroom360Service: Classroom360Service,
    private formWithinDocumentsService: FormWithinDocumentsService
  ) {
    this.alerts = _.cloneDeep(data);
    this.isV10 = this.loginService.LoginSettings.V10;
    this.studentId = this.data.find(d => d.StudentId != undefined).StudentId;
    this.checkAlerts();
    this.getStudentDetails();
  }

  ngOnInit() {
    this.useSection504 = this.loginService.LoginSettings.UseSection504;
  }

  getStudentDetails() {
    const serverCalls: Observable<any> = forkJoin(
      this.studentService.getStudent(this.studentId),
      this.studentService.getStudentEnrollment(this.studentId, this.yearService.defaultYear.Id)
    );

    serverCalls.subscribe(results => {
      if (results[0] != null) {
        this.student = results[0];
      }
      if (results[1] != null) {
        this.studentEnrollment = results[1];
      }
    });
  }

  checkAlerts() {
    // Format the dates for display
    // Null any values that are incorrect
    const userType = this.userService.currentUser.UserType;
    const v10 = this.isV10;
    this.alerts.forEach(alert => {
      alert.StartDate = moment(alert.StartDate, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY');
      alert.EndDate = moment(alert.EndDate, 'YYYY-MM-DDThh:mm:ss').format('MM/DD/YY');
      if (alert.StartDate == '01/01/01') {
        alert.StartDate = '';
      }
      if (alert.EndDate == '01/01/01') {
        alert.EndDate = '';
      }

      if ((alert.AlertType == 'IEP' || alert.AlertType == '504 Special Service') && alert.UserHasPermisison == false) {
        if ((userType == 1 && v10 == true && this.classroom360Service.staffAssignedPortals.filter(o => o.PortalDescription == '/iepAlerts').length > 0)
          || (userType != 1 && this.parentPortalService.parentAssignedPortals.filter(o => o.PortalDescription == '/iepAlerts').length > 0)) {
          alert.UserHasPermisison = true;
          this.isIEP = true;
        }
        else if ((userType == 1 && this.classroom360Service.staffAssignedPortals.filter(o => o.PortalName == 'Programs and Services').length > 0 && alert.Program != '' && alert.Service != '')
          || (userType != 1 && this.parentPortalService.parentAssignedPortals.filter(o => o.PortalName == 'Programs and Services').length > 0 && alert.Program != '' && alert.Service != '')) {
          alert.UserHasPermisison = true;
          this.isIEP = false;
        }
      }
    });
  }

  closeClick() {
    this.dialogRef.close();
  }

  programServiceClick(program: string, service: string) {
    this.studentService.selectedProgramName = program;
    this.studentService.selectedServiceName = service;
    if (this.studentService.selectedStudent == null || this.studentService.selectedStudent.Id != this.student.Id) {
      this.studentService.selectedStudent = this.student;
      this.studentService.studentEnrollment = this.studentEnrollment;
    }
    if (this.studentService.students == null || this.studentService.students.filter(o => o.Id == this.student.Id).length == 0) {
      this.studentService.students = [];
      this.studentService.students.push(this.student);
    }

    this.userService.selectedStudentInfoPortal = 'Programs and Services';
    this.portalDialog = this.dialog.open(StudentInfoPortalComponent, {
      panelClass: 'tyl-mat-dialog', width: '100%', minWidth: '100%', height: '100%', disableClose: true
    });

    this.portalDialog.componentInstance.showPortal('Programs and Services');
    this.portalDialog.afterClosed().subscribe(() => {
      this.student = this.studentService.selectedStudent;
    });

    this.dialogRef.close();
  }

  iepClick(alert) {
    if (this.studentService.selectedStudent == null || this.studentService.selectedStudent.Id != this.student.Id) {
      this.studentService.selectedStudent = this.student;
      this.studentService.studentEnrollment = this.studentEnrollment;
    }
    if (this.studentService.students == null || this.studentService.students.filter(o => o.Id == this.student.Id).length == 0) {
      this.studentService.students = [];
      this.studentService.students.push(this.student);
    }
    if ((this.loginService.LoginSettings.UseSection504 == true || this.loginService.LoginSettings.EnableSped360 == true) && alert.Description == 'Special Services' && alert.Program == 'Doc' && this.userService.userType == 1 && this.isV10 == false && this.router.url.indexOf('spedFormsWithinDocuments') > -1 && this.formWithinDocumentsService.editHtmlFormDialogOpen == true) {
      this.formWithinDocumentsService.callFromAlertDialog = true;
      const addEditReferralDialog = this.dialog.openDialogs.find(o => o.componentInstance instanceof EditHtmlFormComponent);
      if (addEditReferralDialog) {
        (addEditReferralDialog.componentInstance as EditHtmlFormComponent).closeClick('close');
      }
    }
    else if ((this.loginService.LoginSettings.UseSection504 == true || this.loginService.LoginSettings.EnableSped360 == true) && alert.Description == 'Special Services' && alert.Program == 'Doc' && this.userService.userType == 1 && this.isV10 == false && (this.router.url.indexOf('studentDocumentHome') == -1 || (this.router.url.indexOf('studentDocumentHome') > -1 && this.studentService.selectedStudent.Id != this.student.Id)) && this.formWithinDocumentsService.editHtmlFormDialogOpen == false) {
      this.router.navigateByUrl('/sped360/studentDocumentHome');
      this.dialog.closeAll();
    }
    else if (this.isIEP == true && alert.Program && alert.Program != '') {
      this.programServiceClick(alert.Program, alert.Service);
    }
    else {
      if (this.isIEP == true) {
        if (this.loginService.LoginSettings.SDMIntegration != null && this.loginService.LoginSettings.SDMIntegration == true) {
          this.userService.selectedStudentInfoPortal = 'Student Document Management';
        }
        else {
          this.userService.selectedStudentInfoPortal = this.isV10 == true ? 'Individualized Education Program' : 'Special Services';
        }
        this.portalDialog = this.dialog.open(StudentInfoPortalComponent, {
          panelClass: 'tyl-mat-dialog', width: '100%', minWidth: '100%', height: '100%', disableClose: true
        });

        if (this.loginService.LoginSettings.SDMIntegration != null && this.loginService.LoginSettings.SDMIntegration == true) {
          this.portalDialog.componentInstance.showPortal('Student Document Management');
        }
        else {
          this.portalDialog.componentInstance.showPortal(this.isV10 == true ? 'Individualized Education Program' : 'Special Services');
        }
        this.portalDialog.afterClosed().subscribe(() => {
          this.student = this.studentService.selectedStudent;
        });
      }
      else if (this.isIEP == false && alert.Program != '' && alert.Service != '') {
        this.programServiceClick(alert.Program, alert.Service);
      }
    }
    this.dialogRef.close();
  }
}

export class Alert {
  AlertIcon: string;
  AlertType: string;
  ContactName: string;
  ContactRelationship: string;
  Description: string;
  EndDate: string;
  Id: number;
  IsConfidential: boolean;
  Program: string;
  Sequence: number;
  Service: string;
  StartDate: string;
  StudentId: number;
  UserHasPermisison: boolean;
}
